import {Box, SvgIconProps, Typography} from "@mui/material";
import Lock from "./Lock";

interface HundredPercentSafeProps extends SvgIconProps {
    text: string;
}

export default function HundredPercentSafe(props: HundredPercentSafeProps) {
    const {viewBox, text, ...restProps} = props;
    return (
        <Box sx={{
            borderRadius: '50%',
            backgroundColor: (theme) => theme.palette.primary.main,
            color: (theme) => theme.palette.primary.contrastText,
            height: '52px',
            width: '52px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            userSelect: 'none'
        }}>
            <Lock sx={{height: '18px', width: '18px', marginBottom: '5px'}}/>
            <Box sx={{marginBottom: '4px'}}>
                <Typography sx={{fontSize: '7px', fontWeight: 'bold', textAlign: 'center', lineHeight: 1.1}}>100%</Typography>
                <Typography sx={{fontSize: '7px', fontWeight: 'bold', textAlign: 'center', lineHeight: 1.1}}>{text.toUpperCase()}</Typography>
            </Box>
        </Box>
    );
}